import { render, staticRenderFns } from "./MobileVideoCall.vue?vue&type=template&id=6e2f1bc8&scoped=true"
import script from "./MobileVideoCall.vue?vue&type=script&lang=js"
export * from "./MobileVideoCall.vue?vue&type=script&lang=js"
import style0 from "./MobileVideoCall.scss?vue&type=style&index=0&id=6e2f1bc8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f1bc8",
  null
  
)

export default component.exports